// extracted by mini-css-extract-plugin
module.exports = {"root":"PianoToMidi_root__NZCG8","btn":"PianoToMidi_btn__7rby5"};